import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
  MenuItem,
  Snackbar,
} from "@mui/material";
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  CTSinputNo,
  HandleCloseSnackbar,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import {
  addInternalMovement,
  getInternalMovementList,
  editDeleteInternalMovement,
  getCylinderList,
  getLocationList,
  getProductList,
} from "../../../actions/actions";
import depotMasterService from '../../../services/masters/depotMaster.Service';
import productMasterService from '../../../services/masters/productMaster.Service';
import cylinderMasterService from '../../../services/masters/cylinderMaster.Service';
import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
import driverMasterService from '../../../services/masters/driverMaster.Service';
import locationMasterService from '../../../services/masters/locationMaster.Service';
import internalMovementService from "../../../services/internalMovement.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import dayjs from "dayjs";


const InternalMovementAdd = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const depot_id = userInfo.depot_id;
  const short_code = userInfo.short_code;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.internal_transfer_id : null;
  let navigate = useNavigate();
  const [isSet, setIsSet] = useState(false);


  const [data, setData] = useState({
    internal_entry_no: editData ? editData.internal_entry_no : "",
    entry_date: editData?.entry_date? new Date(editData.entry_date).toISOString().split("T")[0]: "",
    from_location: editData ? editData.from_location : "",
    to_location: editData ? editData.to_location : "",
    approved_by: editData ? editData.approved_by : userInfo.user_name,
    fin_year: editData ? editData.fin_year : "",
    
  });

  const [totalCount, setTotalCount] = useState(0);
  const [lastEntryNo, setLastEntryNo] = useState(0);

  const [product, setProduct] = useState([]);
   const [depot, setDepot] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [location, setLocation] = useState([]);
  const [internal_movement, setInternal_movement] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [productData, cylinderData, locationData, internalMovementData,depotData] = await Promise.all([
          productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
          cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
          locationMasterService.getLocationList({ page: 0, size: 999, searchKey: "" }),
          internalMovementService.getInternalMovementList({ page: 0, size: 999, searchKey: "" }),
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
        ]);

        setProduct(productData);
        setCylinder(cylinderData);
        setLocation(locationData);
        setInternal_movement(internalMovementData);
        setDepot(depotData)
      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }

    fetchData();
  }, []);

  const [warningMessage, setWarningMessage] = useState("");

  // const handleChange = ({ target }) => {
  //   const value = target.value;
  //   if (target.name === "from_location" && value === data.to_location) {
  //     setWarningMessage("Location cannot be the same.");
  //   } else if (target.name === "to_location" && value === data.from_location) {
  //     setWarningMessage("Location cannot be the same.");
  //   } else {
  //     setWarningMessage("");
  //     setData({
  //       ...data,
  //       [target.name]: value,
  //     });
  //   }
  // };

  const handleChange = ({ target }) => {
  const { name, value } = target;

  // Check for same location conflict
  if ((name === "from_location" && value === data.to_location) ||
      (name === "to_location" && value === data.from_location)) {
    setWarningMessage("Location cannot be the same.");
  } else {
    setWarningMessage("");

    const updatedData = {
      ...data,
      [name]: value,
    };

    // Add financial year if entry_date is updated
    if (name === "entry_date") {
      const selectedDate = new Date(value);
      const month = selectedDate.getMonth(); // Jan = 0
      const year = selectedDate.getFullYear();
      const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
      updatedData.fin_year = financialYear;
    }

    setData(updatedData);
  }
};


  const onSubmit = async (event) => {
    const isEdit = !!editData;
    const ime_Data = {

      ...data,
      internal_transfer_id: editid,
      table_details: JSON.stringify(table_details),
      changedUpdatedValue: "edit",
      modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      modified_by: isEdit ? userInfo.user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: isEdit ? editData.created_by : userInfo.user_id,
      approved_by: isEdit ? editData.approved_by : userInfo.user_name,
      depot_id: depot_id,
      short_code: short_code,
    };
    try {
      if (editData) {
        await internalMovementService.editDeleteInternalMovement(ime_Data);
      } else {
        await internalMovementService.addInternalMovement(ime_Data);
      }
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
    } catch (error) {
      setSuccessMessage("Error occurred");
    }
  };

  const [isUpdateArray, setIsUpdateArray] = useState(false);

  const [table_details, setTable_details] = useState(
    editData
      ? JSON.parse(editData.table_details)
      : [
        {
          srno: "",
          cyl_no: "",
          prod_code: "",
          prod_description: "",
          qty: "",
          uom: "",
          cyl_type: "",
        },
      ]
  );

  const handleChangeInput = (e, index) => {
    const { name, value } = e.target;
    const updatedTableDetails = [...table_details];

    // Update the changed field
    updatedTableDetails[index] = {
      ...updatedTableDetails[index],
      [name]: value,
      srno: index + 1,
    };

    // When cylinder number is changed, auto-fill prod_code and prod_description
    if (name === "cyl_no" && value) {
      const selectedCylinder = cylinder.find(
        (cyl) => cyl.cylinder_no?.trim().toLowerCase() === value.trim().toLowerCase()
      );

      if (selectedCylinder) {
        updatedTableDetails[index].prod_code = selectedCylinder.prod_code || "";

        const selectedProduct = product.find(
          (prod) =>
            prod.prod_code?.trim().toLowerCase() ===
            selectedCylinder.prod_code?.trim().toLowerCase()
        );

        updatedTableDetails[index].prod_description =
          selectedProduct?.prod_description || "";
      } else {
        updatedTableDetails[index].prod_code = "";
        updatedTableDetails[index].prod_description = "";
      }
    }

    // ✅ Update the state to trigger re-render
    setTable_details(updatedTableDetails);
  };



  const handleRemoveImeDetails = (index) => {
    const values = [...table_details];
    values.splice(index, 1);
    setTable_details(values);
    setIsUpdateArray(!isUpdateArray);
  };

  const handleAddImeFields = () => {
    setTable_details([
      ...table_details,
      {
        srno: table_details.length + 1,
        cyl_no: "",
        prod_code: "",
        prod_description: "",
        qty: "",
        uom: "",
        cyl_type: "",
      },
    ]);
  };

  const [successMessage, setSuccessMessage] = useState(null);

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Internal Movement Entry " }]} />
        <Box>
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
              <Grid item md={7} sm={6} xs={12}>
                <Box sx={{ display: "flex" }}>
                  <Typography className={`${styles.header_txt}`}>
                    Add Internal Transfer Entry
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ justifyContent: 'flex-end', display: 'flex', marginBottom: '20px' }}>
              {editData === null && internal_movement && internal_movement.length > 0 ? (
                <Grid item xs={12}>
                  <Typography className={`${styles.lastEntry_Txt}`}>
                    Last Entry No : {internal_movement[0].lastInternalEntryNo}
                  </Typography>
                </Grid>
              ) : editData === null && internal_movement && internal_movement.length === 0 ? (
                <Grid item xs={12}>
                  <Typography className={`${styles.lastEntry_Txt}`}>
                    Last Entry No : 0
                  </Typography>
                </Grid>
              ) : null}
            </Box>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Grid container spacing={0.6}>
                  <Grid item xs={10} sm={10}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography className={`${styles.label_Txt_add}`}>
                        From Location
                      </Typography>
                      <CTSinput
                        select
                        size="small"
                        fullWidth
                        onChange={handleChange}
                        name="from_location"
                        value={data.from_location}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      >
                        {location &&
                          location.map((location) => (
                            <MenuItem
                              key={location.location_id}
                              value={location.location}
                              className={`${styles.cts_lable}`}
                            >
                              {location.location}
                            </MenuItem>
                          ))}
                      </CTSinput>
                    </Box>
                  </Grid>
                  <Grid item xs={10} sm={10}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography className={`${styles.label_Txt_add}`}>
                        To Location
                      </Typography>
                      <CTSinput
                        select
                        size="small"
                        fullWidth
                        onChange={handleChange}
                        name="to_location"
                        value={data.to_location}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      >
                        {location &&
                          location.map((location) => (
                            <MenuItem
                              key={location.location_id}
                              value={location.location}
                              className={`${styles.cts_lable}`}
                            >
                              {location.location}
                            </MenuItem>
                          ))}
                      </CTSinput>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container spacing={0.6}>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography className={`${styles.label_Txt_add}`}>
                        Entry Date
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        type="date"
                        onChange={handleChange}
                        name="entry_date"
                        value={data.entry_date}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={5.5}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}
                    >
                      <Typography className={`${styles.label_Txt}`}>
                        Financial Year
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        value={data.fin_year}
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          className: styles.CTSinput_Box,
                          style: {
                            backgroundColor: "#f0f0f0",
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography className={`${styles.label_Txt_add}`}>
                        Entry No
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        value={data.internal_entry_no}
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          className: styles.CTSinput_Box,
                          style: {
                            backgroundColor: "#f0f0f0",
                          },
                        }}
                      />
                    </Box>
                  </Grid>


                  <Grid item xs={12} sm={6}>
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: { xs: "stretch", sm: "center" },
    }}
  >
    <Typography className={styles.label_Txt_add}>
      Depot
    </Typography>
    <CTSinput
      size="small"
      fullWidth
      select
      onChange={handleChange}
      name="depot"
      value={data.depot}
      InputProps={{
        className: styles.CTSinput_Box,
      }}
    >
      {depot.map((location) => (
        <MenuItem
          key={location.depot_id}
          value={location.depot_name}
          className={styles.cts_lable}
        >
          {location.depot_name}
        </MenuItem>
      ))}
    </CTSinput>
  </Box>
</Grid>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}
                    >
                      <Typography className={styles.label_Txt_add}>
                        Approved By
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        name="approved_by"
                        value={data.approved_by || ""}
                        InputProps={{
                          readOnly: true,
                          className: styles.CTSinput_Box,
                        }}
                      />
                    </Box>
                  </Grid>


                </Grid>
              </Grid>



              <Grid item xs={12}>
                <Paper sx={{ width: '100%', }}>
                  <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell align="center" className={`${styles.table_head}`} width="5%">
                            Sr No
                          </StyledTableCell>
                          <StyledTableCell align="left" className={`${styles.table_head}`}>
                            Cylinder No
                          </StyledTableCell>
                          <StyledTableCell align="left" className={`${styles.table_head}`}>
                            Product Code
                          </StyledTableCell>
                          <StyledTableCell align="left" className={`${styles.table_head}`}>
                            Product Description
                          </StyledTableCell>
                          <StyledTableCell align="left" className={`${styles.table_head}`}>
                            Qty
                          </StyledTableCell>
                          <StyledTableCell align="left" className={`${styles.table_head}`}>
                            UOM
                          </StyledTableCell>
                          <StyledTableCell align="left" className={`${styles.table_head}`}>
                            Cylinder Type
                          </StyledTableCell>
                          <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: "#ededed", fontSize: "12px" }}>
                            Action
                          </StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody sx={{ backgroundColor: '#fff' }}>
                        {table_details &&
                          table_details.map((row, index) => (
                            <StyledTableRow key={index}>
                              <StyledTableCell align="center">
                                {index + 1}
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <CTSinput
                                  select
                                  size="small"
                                  fullWidth
                                  onChange={(e) => handleChangeInput(e, index)}
                                  name="cyl_no"
                                  value={row.cyl_no}
                                  variant="standard"
                                  InputLabelProps={{ shrink: true }}
                                >
                                  {cylinder &&
                                    cylinder.map((cylinder) => (
                                      <MenuItem
                                        key={cylinder.cyl_id}
                                        value={cylinder.cylinder_no}
                                        className={`${styles.cts_lable}`}
                                      >
                                        {cylinder.cylinder_no}
                                      </MenuItem>
                                    ))}
                                </CTSinput>
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <CTSinput
                                  size="small"
                                  fullWidth
                                  name="prod_code"
                                  value={row.prod_code}
                                  variant="standard"
                                  InputProps={{
                                    readOnly: true,
                                    style: { backgroundColor: '#f0f0f0' },
                                  }}
                                />
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <CTSinput
                                  size="small"
                                  fullWidth
                                  name="prod_description"
                                  value={row.prod_description}
                                  variant="standard"
                                  InputProps={{
                                    readOnly: true,
                                    style: { backgroundColor: '#f0f0f0' },
                                  }}
                                />
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <CTSinput
                                  fullWidth
                                  size="small"
                                  variant="standard"
                                  placeholder="Enter Qty"
                                  type="text"
                                  name="qty"
                                  value={row.qty}
                                  onChange={(e) => handleChangeInput(e, index)}
                                />
                              </StyledTableCell>
                              <StyledTableCell align="left">
                                <CTSinput
                                  fullWidth
                                  size="small"
                                  variant="standard"
                                  placeholder="Enter UOM"
                                  type="text"
                                  name="uom"
                                  value={row.uom}
                                  onChange={(e) => handleChangeInput(e, index)}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CTSinput
                                  fullWidth
                                  size="small"
                                  variant="standard"
                                  name="cyl_type"
                                  value={row.cyl_type}
                                  onChange={(e) => handleChangeInput(e, index)}
                                  type="text"
                                  InputProps={{
                                    disableUnderline: true,
                                    style: { width: '80%' },
                                  }}
                                >
                                  
                                </CTSinput>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Box style={{ display: "flex", justifyContent: "end" }}>
                                  <IconButton size="small" onClick={handleAddImeFields}>
                                    <AddIcon
                                      sx={{
                                        fontSize: "16px",
                                        color: "#1b52d1",
                                        border: "1px solid #1b52d1",
                                        borderRadius: "50%",
                                      }}
                                    />
                                  </IconButton>
                                  {index === 0 ? (
                                    <IconButton disabled size="small" style={{ fontSize: "12px", color: "red" }}>
                                      <DeleteForeverIcon sx={{ color: "#c0c0c0", fontSize: "18px" }} />
                                    </IconButton>
                                  ) : (
                                    <IconButton
                                      size="small"
                                      onClick={() => handleRemoveImeDetails(index)}
                                      style={{ fontSize: "12px", color: "red" }}
                                    >
                                      <DeleteForeverIcon sx={{ fontSize: "18px" }} />
                                    </IconButton>
                                  )}
                                </Box>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box className={`${styles.btn_container}`}>
                  <Box>
                    <Button id={`${styles.btn_save}`} type="submit">
                      <SaveIcon className={`${styles.btn_cancel_txt}`} />{" "}
                      <Typography className={`${styles.btn_cancel_txt}`}>
                        {editData ? "Update" : "Save"}
                      </Typography>
                    </Button>
                  </Box>
                  <Box>
                    <Cancel />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default InternalMovementAdd;